module.exports = __webpack_public_path__ + "static/media/whatsapp1_white.3c8acc15.svg";